import React from 'react';
import styled from 'styled-components';
import { reduxForm } from 'redux-form';
import { func, bool, arrayOf, shape, string, element } from 'prop-types';

import { Button, Dropdown } from 'semantic-ui-react';


const Container = styled.div`
    display: flex;
`;

const Buttons = styled.div`
    flex: 2;
    margin-left: 1rem;
`;

const StyledDropdown = styled(Dropdown)`
    &.ui.dropdown {
        flex: 1;
    }
`;


const SearchFormComponent = ({
    input,
    isFetching,
    isSelected,
    message,
    options,
    handleSearch,
    handleChange,
    handleSave,
    handleCancel,
}) => (
    <Container>
        <StyledDropdown
            fluid
            selection
            placeholder="Search Name/Email"
            onChange={handleChange}
            onSearchChange={handleSearch}
            options={options}
            search={options => options}
            loading={isFetching}
            noResultsMessage={message}
            selectOnNavigation={false}
        />
        <Buttons>
            <Button type="button" content="Save" primary onClick={handleSave} disabled={!isSelected} />
            <Button type="button" content="Cancel" onClick={handleCancel} />
        </Buttons>
    </Container>
);


SearchFormComponent.propTypes = {
    isFetching: bool.isRequired,
    isSelected: bool.isRequired,
    message: string,
    options: arrayOf(shape({
        key: string.isRequired,
        value: string.isRequired,
        text: string.isRequired,
        content: element.isRequired,
    })),
    handleSearch: func.isRequired,
    handleChange: func.isRequired,
    handleSave: func.isRequired,
    handleCancel: func.isRequired,
};

SearchFormComponent.defaultProps = {
    message: 'Search Name/Email',
};

const Search = reduxForm({
    form: 'SearchForm',
    asyncValidate: undefined,
})(SearchFormComponent);

export default Search;
